import { z } from "zod";

export const getArticleBalanceHistoryQuerySchema = z.object({
	startDate: z.string(),
	endDate: z.string(),
});

export type GetArticleBalanceHistoryQuerySchema = z.infer<
	typeof getArticleBalanceHistoryQuerySchema
>;
